const prodConfig = {
  AWS_CONNECT_INSTANCE: 'missionlane-connect',
  CI_TOOL_URL: 'https://ci-tool.external.gcp.missionlane.com/cs',
  ENVIRONMENT: 'production',
  FILEPICKER_API_KEY: 'A8uwROM6BQ4iNPL2K7Fv4z',
  GQL_HOST: 'https://api.missionlane.com/agent/graphql',
  GQL_COOKIE_DOMAIN: '.missionlane.com',
  LAUNCH_DARKLY_CLIENT_ID: '61faaa9f62f81c18129471c1',
  OKTA_CLIENT_ID: '0oaat9dvfcBi47l8i357',
  OKTA_REDIRECT_URI: 'https://mission-control.missionlane.com/login/callback',
  SEGMENT_KEY: '10Q7EfqKJyLGZqBOXI44VMlsGk5aD2wi',
  SNOWFLAKE_STREAMLIT_URI:
    'https://app.snowflake.com/ij90379/missionlane/#/streamlit-apps/EDW_DB.STREAMLIT_INTERNAL_AGENT_TOOLS.ARCHIVED_ACCOUNTS_VIEWER',
  TCS_SSO_URL:
    'https://missionlane.okta.com/home/missionlane_tsystcs_2/0oaaylej6rOaPTfpT357/alnaylp7wpMNkPaQ9357',
  VGS_VAULT_ID: 'tntrscbp87u',
  VGS_ENV: 'live',
  VGS_CNAME: 'mc-vgs.missionlane.com',
  VGS_GQL_PATH: '/agent/graphql',
  ONBASE_FILE_VAULT_URL: 'https://tntrscbp87u.live.verygoodproxy.com',
  // Macros a bulk document request may send. Keyed to the wording in BulkOperationsPage/constants.
  ZENDESK_MACRO_IDS: {
    DOCV: 55261810068243,
    DOCV_WALLET: 55321238753299,
    DOCV_ADDRESS: 55340515232787,
    DOCV_SSC: 55340422904723,
    DOCV_SSC_ADDRESS: 55340555601811,
  },
};

export default prodConfig;
